import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Container, Image, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { useAuth } from 'context/AuthWizardContext';
import { useNavigate, useParams } from 'react-router-dom'; // Yönlendirme için ekleme
import './card.css';

const Solutions = () => {
  const { user } = useAuth();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // useNavigate hook'u ile yönlendirme yapılacak

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axios.post('https://musteri.guardnet.com.tr/call.php', {
          token: user.token,
          process: "100019332"
        });
        if (response.data && response.data.customers) {
          setCustomers(response.data.customers);
        } else {
          setCustomers([]);
        }
      } catch (error) {
        setError('Veriler alınırken bir hata oluştu.');
        console.error('Error fetching customers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, [user.token]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <p className="text-danger">{error}</p>
      </div>
    );
  }

  const cardBackgroundColors = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
  ];

  const handleViewClick = (customerId) => {
    // /admin-panel rotasına yönlendirme
    navigate(`/support/all-requests/${customerId}` );
  };

  return (
    <Container fluid>
      <Row className="gy-4 mt-1">
        {customers.map((customer, index) => (
          <Col xs={12} md={6} lg={4} key={customer.id}>
            <Card
              className="hover-card"
              style={{
                borderRadius: '12px',
                border: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden', // Kartın dışına taşan içerikleri gizle
                height: '200px', // Daha ufak bir kart boyutu
                transition: 'transform 0.3s ease', // Hover efekti için geçiş efekti
              }}
            >
              {/* Logo Kısmı */}
              <div style={{ height: '50%', overflow: 'hidden' }}>
                <Image
                  src={customer.logo || 'https://via.placeholder.com/150'}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  alt={customer.name}
                />
              </div>

              {/* Bilgi Kısmı */}
              <Card.Body
                style={{
                  backgroundColor: cardBackgroundColors[index % cardBackgroundColors.length],
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '10px',
                  height: '70%'
                }}
              >
                <h6>{customer.name}</h6>
                <p>{customer.open_ticket} açık talep</p>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => handleViewClick(customer.id)} // Fonksiyonu doğrudan çağırma
                >
                  Görüntüle
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Solutions;
